import swipeAnimation from "../assets/images/swipe-animation.gif";
import brandLogo from "../assets/images/tata-ev-logo-white.svg";
import brandLogoGrey from "../assets/images/tata-ev-logo.svg";
import shareIcon from "../assets/images/share-icon.svg";
import videoPoster from "../assets/images/video-poster.jpg";
// import footSwipeDummy from "../assets/images/foot-swipe-dummy.png";
import footSwipeDummy from "../assets/images/foot-swipe-dummy.gif";
import crossIcon from "../assets/images/cross-icon.png";
import tryOnQr from "../assets/images/try-on-qr-code.png";
import rotateIcon from "../assets/images/rotate-icon.gif";
import qrSplashIcon from "../assets/images/qr-code-splash.svg";
import brandCar from "../assets/images/car-bg.png";
import playButton from "../assets/images/play-button.svg";
import copyLink from "../assets/images/copy-link.svg";
import mailIcon from "../assets/images/mail.svg";
import shareIconWhite from "../assets/images/share-icon-white.svg";
import closeIconModal from "../assets/images/close_icon_modal.svg";
import feedbackBg from '../assets/images/feedback_bg.png';
import smoothRideIcon from '../assets/images/smooth_ride.svg';
import bumpyIcon from '../assets/images/bumpy.svg';
import notGreatIcon from '../assets/images/not_great.svg';
import backStory from '../assets/images/back-story.svg';
import storyThumbnail from '../assets/images/story-thumb.jpg';
import starRatingBorder from '../assets/images/star-border.svg';
import starRatingFill from '../assets/images/star-fill.svg';

export const mediaData = {
  swipeAnimation,
  brandLogo,
  brandLogoGrey,
  shareIcon,
  videoPoster,
  footSwipeDummy,
  crossIcon,
  tryOnQr,
  rotateIcon,
  qrSplashIcon,
  brandCar,
  playButton,
  copyLink,
  mailIcon,
  shareIconWhite,
  closeIconModal,
  feedbackBg,
  smoothRideIcon,
  bumpyIcon,
  notGreatIcon,
  backStory,
  storyThumbnail,
  starRatingBorder,
  starRatingFill,
};
